module.exports = __webpack_public_path__ + "img/white.1e2d59f.svg";